import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EGroupType;
(function (EGroupType) {
  EGroupType["User"] = "user";
  EGroupType["System"] = "system";
})(EGroupType || (EGroupType = {}));
export const fieldsGroup = _extends({}, fieldsIBaseModel, {
  allFacilities: {
    type: 'Boolean'
  },
  externalId: {
    type: 'Object'
  },
  facilities: {
    type: 'ID',
    ref: EModel.Facility,
    array: true
  },
  name: {
    type: 'Text'
  },
  searchIds: {
    type: 'Text',
    array: true
  },
  type: {
    type: 'Option',
    values: EGroupType
  },
  users: {
    type: 'ID',
    ref: EModel.User,
    array: true
  }
});